import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Instagram, Facebook, MessageCircle } from 'lucide-react';
export function Footer() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      tagline: 'Fine Art Tattoo | Miami, FL',
      rights: '© 2024 KRLY Gold Tattoo. Miami, FL. All rights reserved.'
    },
    es: {
      tagline: 'Tatuaje Fine Art | Miami, FL',
      rights: '© 2024 KRLY Gold Tattoo. Miami, FL. Todos los derechos reservados.'
    }
  };
  const t = content[language];
  return <footer className="relative border-t border-brand-gold/30 overflow-hidden" data-id="element-52">
      <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/fTqV2KPKRdTLDWmc4Laip1/kgt_logo.png')] bg-cover bg-center" data-id="element-53" />
      <div className="absolute inset-0 bg-brand-black/80" data-id="element-54" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-12" data-id="element-55">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center text-center md:text-left" data-id="element-56">
          {/* Left */}
          <div data-id="element-57">
            <h3 className="font-serif text-brand-gold text-xl tracking-widest uppercase mb-2" data-id="element-58">
              KRLY GOLD TATTOO
            </h3>
            <p className="text-brand-white/60 font-sans text-xs tracking-widest uppercase" data-id="element-59">
              {t.tagline}
            </p>
          </div>

          {/* Center - Socials */}
          <div className="flex justify-center gap-6" data-id="element-60">
            <a href="https://instagram.com/krlygoldtattoo" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors" data-id="element-61">
              <Instagram className="w-6 h-6" data-id="element-62" />
            </a>
            <a href="https://www.facebook.com/share/1CqVNdK2Fb/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors" data-id="element-63">
              <Facebook className="w-6 h-6" data-id="element-64" />
            </a>
            <a href="https://www.tiktok.com/@krlygoldtattoo?_r=1&_t=ZT-954UMqLOH9B" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors" data-id="element-65">
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-66">
                <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V9.17a8.16 8.16 0 004.76 1.52v-3.4a4.85 4.85 0 01-1-.6z" data-id="element-67" />
              </svg>
            </a>
            <a href="https://wa.me/13057256699" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors" data-id="element-68">
              <MessageCircle className="w-6 h-6" data-id="element-69" />
            </a>
          </div>

          {/* Right */}
          <div className="md:text-right text-brand-white/40 font-sans text-xs tracking-wider" data-id="element-70">
            <p data-id="element-71">{t.rights}</p>
          </div>
        </div>
      </div>
      <div className="h-px w-full bg-brand-gold/30" data-id="element-72" />
    </footer>;
}